import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ErrorService} from '@app/services';
import {AudioDescription} from '../../audio-description';

@Component({
  selector: 'hpf-audio-description-create',
  templateUrl: './audio-description-create.component.html'
})
export class AudioDescriptionCreateComponent implements OnInit {
  /** The audio description */
  audioDescription = new AudioDescription();

  /** Constructor */
  constructor(private router: Router,
              private errorService: ErrorService) {
  }
  /** Init */
  ngOnInit() {
  }
  /** Called when the audio description is created */
  onCreate(audioDescription: AudioDescription): void {
    this.router.navigateByUrl(`/audio-description/${audioDescription.getId()}`)
      .catch((error) => this.errorService.handle(error));
  }

}
